import { Redo2, Undo2 } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface UndoRedoButtonsProps {
  canUndo: boolean;
  canRedo: boolean;
  undoLabel: string | undefined;
  redoLabel: string | undefined;
  onUndo: () => void;
  onRedo: () => void;
}

const buttonClass = cn(
  'tw:flex tw:h-7 tw:w-8 tw:items-center tw:justify-center tw:border tw:border-ed-umber/30 tw:bg-white tw:text-ed-charcoal',
  'tw:transition-colors tw:hover:bg-ed-gold/10 tw:hover:text-ed-gold',
  'tw:disabled:cursor-not-allowed tw:disabled:opacity-40 tw:disabled:hover:bg-white tw:disabled:hover:text-ed-charcoal',
);

/** Local undo/redo controls for the autosave edit bar. */
export function UndoRedoButtons({
  canUndo,
  canRedo,
  undoLabel,
  redoLabel,
  onUndo,
  onRedo,
}: UndoRedoButtonsProps) {
  return (
    <TooltipProvider>
      <div className='tw:flex tw:items-center'>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type='button'
              disabled={!canUndo}
              onClick={onUndo}
              className={cn(buttonClass, 'tw:rounded-l')}
            >
              <Undo2 className='tw:size-4' />
            </button>
          </TooltipTrigger>
          <TooltipContent side='bottom'>{canUndo ? `Undo: ${undoLabel}` : 'Nothing to undo'}</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type='button'
              disabled={!canRedo}
              onClick={onRedo}
              className={cn(buttonClass, 'tw:-ml-px tw:rounded-r')}
            >
              <Redo2 className='tw:size-4' />
            </button>
          </TooltipTrigger>
          <TooltipContent side='bottom'>{canRedo ? `Redo: ${redoLabel}` : 'Nothing to redo'}</TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}
